import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import URL_MAPPING from "../routes/constants";
import EmpList from "../assets/icons/emp-list.svg";
import EmpListDark from "../assets/icons/emp-list-dark.svg";
import MapView from "../assets/icons/map-view.svg";
import MapViewDark from "../assets/icons/map-view-dark.svg";
import Home from "../assets/icons/home-icon.svg";
import Dashboard from "../assets/icons/dashboard.svg";
import DashboardDark from "../assets/icons/dashboard-dark.svg";
import VisitReport from "../assets/icons/visit-report.svg";
import VisitReportDark from "../assets/icons/visit-report-dark.svg";
import { useTranslation } from "react-i18next";
import DownArrow from "../assets/down-arrow.svg";
import UpArrow from "../assets/up-arrow.svg";
import Reports from "../assets/icons/reports.png"
import KAKRSurvey from "../assets/icons/kakrsurvey.png"
import Reportsdark from "../assets/icons/reportsdark.png"
import KAKRSurveydark from "../assets/icons/kakrdark.png"
import Icon11 from "../assets/icons/icon11.svg"
import Icon11s from "../assets/icons/icon11s.svg"
import Stockreport from "../assets/icons/stockreport.png";
import Stockreportdark from "../assets/icons/stockreportdark.png";
import { getUserInfo } from "../utility";

/** Alphabetical order by visible label (current locale). */
function sortReportSubItemsByLabel<T extends { label?: unknown }>(items: T[]): T[] {
  return [...items].sort((a, b) =>
    String(a.label ?? "").localeCompare(String(b.label ?? ""), undefined, { sensitivity: "base" })
  );
}

interface NavbarProps {
  open: boolean;
  setOpen: any;
}
const Navbar: React.FC<NavbarProps> = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [navItems, setNavItems] = useState<any>([]);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null); // Track the hovered item
  const navRef = useRef<HTMLDivElement>(null);
  const isActive = (route: string) => location.pathname === route;
  const [isRTL, setIsRTL] = useState(false);
  const [isReportsOpen, setIsReportsOpen] = useState(false);
  const [isHorecaReportsOpen, setIsHorecaReportsOpen] = useState(false);
  const [isSupervisorOpen, setIsSupervisorOpen] = useState(false);
  const activeMenu = useRef('');
  const [role, setRole] = useState<string>(getUserInfo()?.role);

  const isPresent = ['102910', 'AV0001', '106097', '105822'].includes(getUserInfo()?.emp_id)
  const canViewDeliveryHeatmap = ['102910', 'AV0001'].includes(getUserInfo()?.emp_id);

  const newObj = {
    route: URL_MAPPING.TARGETKPI,
    label: t("Nav.analytics"),
    icon: Icon11,
    iconDark: Icon11s,
  }

  useEffect(() => {


  }, [navItems])

  const handleSubMenuClick = (route: string, item: any) => {
    activeMenu.current = item.label
    navigate(route);
    setIsReportsOpen(false);
    setIsHorecaReportsOpen(false);
    setIsSupervisorOpen(false);
    setOpen(false);
  };

  const handleSection = async (section: any) => {
    // const accessibleReports = await getAccessibleReports();
    // const accessibleReportNames = accessibleReports.data.map((report:any) => report.report_type);
    const accessibleReportNames = ['VISIT_REPORT', 'ACTIVITY_REPORT']

    const horecaReportsMenu = {
      label: t("Nav.horecaReports"),
      icon: Reportsdark,
      iconDark: Reports,
      isCollapsible: true,
      subItems: sortReportSubItemsByLabel([
        {
          route: URL_MAPPING.HORECAVISITREPORT,
          label: t("Nav.horecaVisitSummary"),
        },
        {
          route: URL_MAPPING.HORECAACTIVITYREPORT,
          label: t("Nav.horecaActivityReport"),
        },
        {
          route: URL_MAPPING.HORECACOLLECTIONREPORT,
          label: "Collection Report",
        },
        {
          route: URL_MAPPING.HORECASTOCKREPORT,
          label: "Stock Report",
        },
        {
          route: URL_MAPPING.HORECAQUATERLYCONFIRMATIONREPORT,
          label: "Quaterly Confirmation Report",
        }

      ]),
    };

    //  todo:need to verify and implement 
    switch (section) {
      case "My Team":
        isPresent ?
          setNavItems([
            {
              route: URL_MAPPING.LANDING,
              label: t("Nav.home"),
              icon: Home,
              iconDark: Home, // Assuming Home doesn't have a dark version
            },
            {
              route: URL_MAPPING.ANALYTICS,
              label: t("Nav.dashboard"),
              icon: Dashboard,
              iconDark: DashboardDark,
            },
            {
              route: URL_MAPPING.TARGETKPI,
              label: t("Nav.analytics"),
              icon: Icon11,
              iconDark: Icon11s,
            },
            {
              route: URL_MAPPING.MAPVIEW,
              label: t("Nav.mapView"),
              icon: MapView,
              iconDark: MapViewDark,
            },
            {
              route: URL_MAPPING.PLANOGRAM,
              label: t("Nav.planogramreport"),
              icon: EmpList,
              iconDark: EmpListDark,
            },
            {
              label: t("Nav.reports"),
              icon: Reportsdark,
              iconDark: Reports,
              isCollapsible: true,
              subItems: sortReportSubItemsByLabel([
                ...(accessibleReportNames.includes("VISIT_REPORT") ? [
                  {
                    route: URL_MAPPING.CALLPLANREPORT,
                    label: t("Nav.callplanreport"),
                  }] : []),
                ...(accessibleReportNames.includes("VISIT_REPORT") ? [
                  {
                    route: URL_MAPPING.VISITREPORT,
                    label: t("Nav.visitsReport"),
                  }] : []),
                {
                  route: URL_MAPPING.VIDEO_VIEW_REPORT,
                  label: "Video view report",
                },
                ...(accessibleReportNames.includes("ACTIVITY_REPORT") ? [
                  {
                    route: URL_MAPPING.ACTIVITYREPORT,
                    label: t("Nav.activityReport"),
                  }] : []),
                ...(accessibleReportNames.includes("ACTIVITY_REPORT") ? [
                  {
                    route: URL_MAPPING.MASTERLIST,
                    label: t("Nav.masterList"),
                  }] : []),
                {
                  route: URL_MAPPING.KAKRREPORT,
                  label: t("Nav.kakrreport"),
                },
                {
                  route: URL_MAPPING.STOCKREPORT,
                  label: t("Nav.kakrstockreport"),
                },
                {
                  route: URL_MAPPING.SUPERVISORCUSTOMERCREATION,
                  label: t("Nav.customercreation"),
                },
                {
                  route: URL_MAPPING.SUPERVISORLOCATIONCAPTURE,
                  label: t("Nav.locationcapture"),
                },
                {
                  route: URL_MAPPING.SUPERVISORCOLLECTIONREPORT,
                  label: t("Nav.collection"),
                },
                {
                  route: URL_MAPPING.SUPERVISORPOREPORT,
                  label: t("Nav.poreport"),
                },
                {
                  route: URL_MAPPING.DELIVERYIMAGESREPORT,
                  label: "Delivery Images Report",
                },
                {
                  route: URL_MAPPING.SFAFEEDBACKCUSTOMERREPORT,
                  label: "Customer Survey Report",
                },
                {
                  route: URL_MAPPING.SHOPLICENSEREPORT,
                  label: "Shop License Report",
                },

              ]), ...(isPresent ? [{
                route: URL_MAPPING.TARGETKPI,
                label: t("Nav.analytics"),
              }] : [])

            },
            horecaReportsMenu,
            // role !== 'DD Supervisor' && {
            //   label: t("Nav.supervisor"),
            //   icon: Reportsdark,
            //   iconDark: Reports,
            //   isCollapsible: true,
            //   subItems: [
            //                     {
            //       route: URL_MAPPING.SUPERVISORDASHBOARD,
            //       label: t("Nav.dashboard"),
            //       icon: Dashboard,
            //       iconDark: DashboardDark,
            //     },
            //     {
            //       route: URL_MAPPING.SUPERVISORACTIVITYREPORT,
            //       label: t("Nav.activityReport"),
            //       icon: VisitReport,
            //       iconDark: VisitReportDark,
            //     },
            //     {
            //       route: URL_MAPPING.SUPERVISORCOLLECTIONAUDIT,
            //       label: t("Nav.collectionAudit"),
            //       icon: EmpList,
            //       iconDark: EmpListDark
            //     },
            //     {
            //       route: URL_MAPPING.SUPERVISORVISITREPORT,
            //       label: t("Nav.supervisorVisitReport"),
            //       icon: EmpList,
            //       iconDark: EmpListDark
            //     },
            //     {
            //       route: URL_MAPPING.SUPERVISORMAP,
            //       label: t("Nav.mapView"),
            //       icon: MapView,
            //       iconDark: MapViewDark,
            //     }
            //   ],
            // },
          ]) :
          setNavItems([
            {
              route: URL_MAPPING.LANDING,
              label: t("Nav.home"),
              icon: Home,
              iconDark: Home, // Assuming Home doesn't have a dark version
            },
            {
              route: URL_MAPPING.ANALYTICS,
              label: t("Nav.dashboard"),
              icon: Dashboard,
              iconDark: DashboardDark,
            },
            {
              route: URL_MAPPING.MAPVIEW,
              label: t("Nav.mapView"),
              icon: MapView,
              iconDark: MapViewDark,
            },
            {
              route: URL_MAPPING.PLANOGRAM,
              label: t("Nav.planogramreport"),
              icon: EmpList,
              iconDark: EmpListDark,
            },
            {
              label: t("Nav.reports"),
              icon: Reportsdark,
              iconDark: Reports,
              isCollapsible: true,
              subItems: sortReportSubItemsByLabel([
                 ...(accessibleReportNames.includes("VISIT_REPORT") ? [
                  {
                    route: URL_MAPPING.CALLPLANREPORT,
                    label: t("Nav.callplanreport"),
                  }] : []),
                ...(accessibleReportNames.includes("VISIT_REPORT") ? [
                  {
                    route: URL_MAPPING.VISITREPORT,
                    label: t("Nav.visitsReport"),
                  }] : []),
                {
                  route: URL_MAPPING.VIDEO_VIEW_REPORT,
                  label: "Video view report",
                },
                ...(accessibleReportNames.includes("ACTIVITY_REPORT") ? [
                  {
                    route: URL_MAPPING.ACTIVITYREPORT,
                    label: t("Nav.activityReport"),
                  }] : []),
                ...(accessibleReportNames.includes("ACTIVITY_REPORT") ? [
                  {
                    route: URL_MAPPING.MASTERLIST,
                    label: t("Nav.masterList"),
                  }] : []),
                {
                  route: URL_MAPPING.KAKRREPORT,
                  label: t("Nav.kakrreport"),
                },
                {
                  route: URL_MAPPING.STOCKREPORT,
                  label: t("Nav.kakrstockreport"),
                },
                {
                  route: URL_MAPPING.SUPERVISORCUSTOMERCREATION,
                  label: t("Nav.customercreation"),
                },
                {
                  route: URL_MAPPING.SUPERVISORLOCATIONCAPTURE,
                  label: t("Nav.locationcapture"),
                },
                {
                  route: URL_MAPPING.SUPERVISORCOLLECTIONREPORT,
                  label: t("Nav.collection"),
                },
                {
                  route: URL_MAPPING.SUPERVISORPOREPORT,
                  label: t("Nav.poreport"),
                },

              ]), ...(isPresent ? [{
                route: URL_MAPPING.TARGETKPI,
                label: t("Nav.analytics"),
              }] : [])

            },
            horecaReportsMenu,
           
          ]);
          break
          case "Supervisor":
            setNavItems([
    
              {
                route: URL_MAPPING.LANDING,
                label: t("Nav.home"),
                icon: Home,
                iconDark: Home,
              },
              {
                route: URL_MAPPING.SUPERVISORDASHBOARD,
                label: t("Nav.dashboard"),
                icon: Dashboard,
                iconDark: DashboardDark,
              },
              {
                route: URL_MAPPING.SUPERVISORACTIVITYREPORT,
                label: t("Nav.activityReport"),
                icon: VisitReport,
                iconDark: VisitReportDark,
              },
              {
                route: URL_MAPPING.SUPERVISORCOLLECTIONAUDIT,
                label: t("Nav.collectionAudit"),
                icon: EmpList,
                iconDark: EmpListDark
              },
              {
                route: URL_MAPPING.SUPERVISORVISITREPORT,
                label: t("Nav.supervisorVisitReport"),
                icon: EmpList,
                iconDark: EmpListDark
              },
              {
                route: URL_MAPPING.SUPERVISORMAP,
                label: t("Nav.mapView"),
                icon: MapView,
                iconDark: MapViewDark,
              }
            ]);
            break;
        break;
      case "Customers":
        setNavItems([
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
            iconDark: Home, // Assuming Home doesn't have a dark version
          },
          {
            route: URL_MAPPING.MASTERLIST,
            label: t("Nav.masterList"),
            icon: EmpList,
            iconDark: EmpListDark,
          },
        ]);

        break;
      case "Planogram":
        setNavItems([
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
            iconDark: Home, // Assuming Home doesn't have a dark version
          },
          {
            route: URL_MAPPING.PLANOGRAM,
            label: t("Nav.planogramreport"),
            icon: EmpList,
            iconDark: EmpListDark,
          },
        ]);
        break;
      case "Admin":
        setNavItems([
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
            iconDark: Home,
          },
        ]);
        break;
      case "Print":
        setNavItems([
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
            iconDark: Home,
          },
          {
            route: URL_MAPPING.DEPOSITREPORT,
            label: t("Nav.depositreport"),
            icon: VisitReport,
            iconDark: VisitReportDark,
          },
          {
            route: URL_MAPPING.SALESREPORT,
            label: t("Nav.salesreport"),
            icon: EmpList,
            iconDark: EmpListDark,
          },
          {
            route: URL_MAPPING.INVOICEREPORT,
            label: t("Nav.invoicereport"),
            icon: MapView,
            iconDark: MapViewDark,
          },
        ]);
        break;
      case "Finance":
        setNavItems([
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
            iconDark: Home,
          },
          {
            route: URL_MAPPING.DEPOSITREPORT,
            label: t("Nav.depositreport"),
            icon: VisitReport,
            iconDark: VisitReportDark,
          },
          {
            route: URL_MAPPING.SALESREPORT,
            label: t("Nav.salesreport"),
            icon: EmpList,
            iconDark: EmpListDark,
          },
          {
            route: URL_MAPPING.INVOICEREPORT,
            label: t("Nav.invoicereport"),
            icon: MapView,
            iconDark: MapViewDark,
          },
        ]);
        break;
      case "Territory":
        setNavItems([
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
              iconDark: Home,
            },
            {
              route: URL_MAPPING.TERRITORYMAPVIEW,
              label: "LMD Territory",
              icon: MapView,
              iconDark: MapViewDark,
          },
 
            {
              route: URL_MAPPING.LMDTERRITORY,
              label: "Territory Mapping",
              icon: MapView,
              iconDark: MapViewDark,
            },

        ]);
        break;
      case "Delivery_My_Team":
        setNavItems([
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
            iconDark: Home,
          },
          {
            route: URL_MAPPING.DELIVERYDASHBOARD,
            label: t("Nav.dashboard"),
            icon: Dashboard,
            iconDark: DashboardDark,
          },
          {
            route: URL_MAPPING.MAPVIEW,
            label: t("Nav.mapView"),
            icon: MapView,
            iconDark: MapViewDark,
          },
          ...(canViewDeliveryHeatmap ? [{
            route: URL_MAPPING.DELIVERYHEATMAP,
            label: "Delivery Heatmap",
            icon: MapView,
            iconDark: MapViewDark,
          }] : []),
          {
            route: URL_MAPPING.OTPGENERATION,
            label: "OTP Generation",
            icon: VisitReport,
            iconDark: VisitReportDark,
          },
          {
            label: t("Nav.reports"),
            icon: Reportsdark,
            iconDark: Reports,
            isCollapsible: true,
            subItems: sortReportSubItemsByLabel([
              {
                route: URL_MAPPING.DELIVERYREPORT,
                label: "Delivery Report",
              },
              {
                route: URL_MAPPING.DELIVERYSUMMARYREPORT,
                label: "Delivery Summary Report",
              },
              {
                route: URL_MAPPING.REJECTIONREPORT,
                label: "Rejection Report",
              },
              {
                route: URL_MAPPING.DELIVERYIMAGESREPORT,
                label: "Delivery Images Report",
              },
              {
                route: URL_MAPPING.OTPCHECKINREPORT,
                label: "OTP Checkin Report",
              },

            ]),
          },
        ]);
        break;
      case "Delivery_Planogram":
        setNavItems([
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
            iconDark: Home, // Assuming Home doesn't have a dark version
          },
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.planogramreport"),
            icon: EmpList,
            iconDark: EmpListDark,
          },
        ]);
        break;
      case "Delivery_Print":
        setNavItems([
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
            iconDark: Home, // Assuming Home doesn't have a dark version
          },
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.reports"),
            icon: Home,
            iconDark: Home, // Assuming Home doesn't have a dark version
          },
        ]);
        break;
      case "B2B":
        setNavItems([
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
            iconDark: Home, // Assuming Home doesn't have a dark version
          },
          {
            route: URL_MAPPING.B2BDASHBOARD,
            label: t("Nav.b2bdashboard"),
            icon: Home,
            iconDark: Home,
          },
          {
            route: URL_MAPPING.B2BREPORT,
            label: t("Nav.b2breport"),
            icon: VisitReport,
            iconDark: VisitReportDark,
          },
          {
            route: URL_MAPPING.B2BFEEDBACKREPORT,
            label: t("Nav.b2bfeedbackreport"),
            icon: VisitReport,
            iconDark: VisitReportDark,
          }
        ]);
        break;
        case "SDR":
        setNavItems([

          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
            iconDark: Home,
          },
          // {
          //   route: URL_MAPPING.SDRDASHBOARD,
          //   label: t("Nav.dashboard"),
          //   icon: Dashboard,
          //   iconDark: DashboardDark,
          // },
             {
              route: URL_MAPPING.MAPVIEW,
              label: t("Nav.mapView"),
              icon: MapView,
              iconDark: MapViewDark,
            },
          {
            route: URL_MAPPING.SDRACTIVITYREPORT,
            label: t("Nav.SDRActivityReport"),
            icon: VisitReport,
            iconDark: VisitReportDark,
          },
          {
            route: URL_MAPPING.SDRACTIVITYREPORT40,
            label: t("Nav.SDRActivityReport40"),
            icon: VisitReport,
            iconDark: VisitReportDark,
          },
          {
            route: URL_MAPPING.SDRVISITREPORT,
            label: t("Nav.SDRVisitSummary"),
            icon: EmpList,
            iconDark: EmpListDark,
          },
                    {
            route: URL_MAPPING.SDRSUMMARYREPORT,
            label: t("Nav.SDRSummary"),
            icon: EmpList,
            iconDark: EmpListDark,
          }
        ]);
        break;
      
        
      default:
        setNavItems([
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
            iconDark: Home, // Assuming Home doesn't have a dark version
          },
        ]);
        break;
    }
  };

  const dir = document.documentElement.getAttribute("dir");
  useEffect(() => {
    const section = localStorage.getItem("section");
    if (!section) {
      navigate(URL_MAPPING.LANDING);
    }
    handleSection(section);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dir]);

  // Update navbar when location changes
  useEffect(() => {
    if (
      location.pathname === URL_MAPPING.HORECAVISITREPORT ||
      location.pathname === URL_MAPPING.HORECAACTIVITYREPORT
    ) {
      const currentSection = localStorage.getItem("section");
      if (currentSection !== "My Team") {
        localStorage.setItem("section", "My Team");
        handleSection("My Team");
        return;
      }
    }

    // If on a territory route, ensure section is set
    if (location.pathname === URL_MAPPING.LMDTERRITORY || location.pathname === URL_MAPPING.TERRITORYMAPVIEW) {
      const currentSection = localStorage.getItem("section");
      if (currentSection !== "Territory") {
        localStorage.setItem("section", "Territory");
        handleSection("Territory");
        return;
      }
    }
    
    const section = localStorage.getItem("section");
    if (section) {
      handleSection(section);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    let isRtl = false;
    isRtl = dir === "rtl";
    setIsRTL(isRtl);
  }, [dir]);

  const handleClickOutside = (event: MouseEvent) => {
    if (navRef.current && !navRef.current.contains(event.target as Node)) {
      setOpen(false); // Close the Navbar when clicking outside
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getActiveItem = (items: { route: string }[]): boolean => {
    return items?.some(item => location.pathname === item.route);
  };

  return (
    <div
      ref={navRef}
      className={` md:flex h-screen md:h-[calc(100%-51px)] border-2 bg-[#FFFFFF] flex flex-col justify-start items-center absolute ${isRTL ? "right-0" : "left-0"
        } gap-0 z-30 top-0 md:top-[48px] ${open ? "w-[251px] md:w-[220px]" : "hidden w-[56px] delay-150"} transition-all duration-300`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => {
        setOpen(false);
        setIsReportsOpen(false);
        setIsHorecaReportsOpen(false);
        setIsSupervisorOpen(false);
      }}
    >
      <ul className=" flex flex-col items-center justify-start gap-1 mt-4 w-full overflow-hidden min-h-[600px] h-auto">
        {navItems.map((item: any, index: number) => {
          return (
            <li
              key={index}
              className={`relative  w-full items-center h-[54px] px-2 flex ${item.route === URL_MAPPING.LANDING
                ? "hover:bg-[#F3E6F4] hover:text-purple relative"
                : ""
                } group cursor-pointer ${isActive(item.route) || getActiveItem(item.subItems)
                  ? "bg-[#B0F7F5]"
                  : ""
                }`}
            >
              <button
                className=" p-2 flex gap-2 cursor-pointer items-center w-full justify-between"
                onClick={() => {
                  if (item.isCollapsible) {
                    if (item.label === t("Nav.reports")) {
                      setIsReportsOpen((prev) => !prev);
                      setIsHorecaReportsOpen(false);
                      setIsSupervisorOpen(false);
                    } else if (item.label === t("Nav.horecaReports")) {
                      setIsHorecaReportsOpen((prev) => !prev);
                      setIsReportsOpen(false);
                      setIsSupervisorOpen(false);
                    } else if (item.label === t("Nav.supervisor")) {
                      setIsSupervisorOpen((prev) => !prev);
                      setIsReportsOpen(false);
                      setIsHorecaReportsOpen(false);
                    }
                    activeMenu.current = item.label;
                  } else {
                    navigate(item.route);
                  }
                }}
              >
                <div className="flex gap-2 items-center min-w-0">
                  <img
                    src={
                      isActive(item.route) ||
                        hoveredIndex === index || getActiveItem(item.subItems)
                        ? item.iconDark
                        : item.icon
                    }
                    alt={item.label}
                    className="max-w-[50px]"
                  />
                  <p
                    className={`transition-opacity duration-200 delay-150 ${open ? "opacity-100" : "opacity-0"
                      } group-hover:opacity-100 group-hover:text-black ${isActive(item.route) || getActiveItem(item.subItems)
                        ? "text-black"
                        : "text-grey"
                      } text-sm truncate flex-1`}
                  >
                    {item.label}
                  </p>
                </div>

                {/* Add down arrow for collapsible items */}
                {item.isCollapsible && (
                  <span>
                    <img src={((isReportsOpen && item.label === t("Nav.reports")) || (isHorecaReportsOpen && item.label === t("Nav.horecaReports")) || (isSupervisorOpen && item.label === t("Nav.supervisor"))) ? UpArrow : DownArrow} alt="" />
                  </span>
                )}
              </button>
              {((isReportsOpen && item.label === t("Nav.reports")) || (isHorecaReportsOpen && item.label === t("Nav.horecaReports")) || (isSupervisorOpen && item.label === t("Nav.supervisor"))) && (
                <ul
                  className={`absolute border-b-2 bg-white overflow-y-auto flex flex-col gap-2 z-50 submenu transition-opacity duration-200 delay-150 ${isRTL ? "right-[25px]" : ""}`}
                  style={{
                    top: "100%",
                    minWidth: "210px",
                    maxHeight: item.label === t("Nav.reports") ? "250px" : "200px",
                    overflowY: "auto",
                    position: "absolute",
                    zIndex: 50,
                  }}
                >
                  {item?.subItems?.map((subItem: any, subIndex: number) => (
                    <li
                      key={subIndex}
                      onClick={() => handleSubMenuClick(subItem.route, item)}
                      className={` w-full  items-center h-[54px] p-2 flex group cursor-pointer ${isActive(subItem.route) ? " bg-[#B0F7F5]" : "group-hover:text-black"
                        }`}
                    >
                      <button className="p-2 flex items-center min-w-0 w-full justify-start">
                        <p
                          className={`transition-opacity duration-200 delay-150 text-sm ${open ? "opacity-100" : "opacity-0"
                            } group-hover:opacity-100 hover:text-black ${isActive(subItem.route) ? "text-black " : "text-grey"
                            } truncate flex-1 text-left`}
                        >
                          {subItem.label}
                        </p>
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>

      {/* Submenu */}

    </div>




  );
};

export default Navbar;